export * from '@primeuix/themes/nora/toggleswitch';
export { default } from '@primeuix/themes/nora/toggleswitch';
